import React from 'react';
import type { CruisePortPreviewRow } from '../../services/cruiseItinerariesApi';
import { FerryIcon, HotelIcon, TransportIcon } from '../icons/TripIcons';
import styles from './CruisePortStopPreview.module.css';

interface CruisePortStopPreviewProps {
  row: CruisePortPreviewRow;
}

const CruisePortStopPreview: React.FC<CruisePortStopPreviewProps> = ({ row }) => (
  <div className={styles.row}>
    <PortStopIcon kind={row.icon} />
    <div className={styles.text}>
      <div className={styles.name}>{row.name}</div>
      <div className={styles.date}>{row.dateLabel}</div>
      {row.timeLine ? <div className={styles.time}>{row.timeLine}</div> : null}
    </div>
  </div>
);

const PortStopIcon: React.FC<{ kind: CruisePortPreviewRow['icon'] }> = ({ kind }) => {
  if (kind === 'atSeaOrCruising') {
    return (
      <span className={styles.icon} aria-hidden>
        <FerryIcon size={22} />
      </span>
    );
  }
  if (kind === 'flight') {
    return (
      <span className={styles.icon} aria-hidden>
        <TransportIcon size={22} />
      </span>
    );
  }
  if (kind === 'hotel') {
    return (
      <span className={styles.icon} aria-hidden>
        <HotelIcon size={22} />
      </span>
    );
  }
  return (
    <img
      className={styles.portPin}
      src="/images/port-pin.png"
      alt=""
      width={24}
      height={36}
      decoding="async"
    />
  );
};

export default CruisePortStopPreview;
